"use strict";

const MuniOpenChannelFilters = function () {
  const searchDbFields = ["name"];
  const searchFields = ["name"];

  var filterResourceDataHandler = (unfilteredData, filters, loadingScreen, smartFilters) =>
    smartFilters ? smartFilters.filter(unfilteredData, filters) : unfilteredData;

  var addGeoServerViewParams = function (params, filters) {
    GeoServerFilterFunctions.addSpatialFilterViewParams(params, filters);
    if (!SmartFilterRegistry.getSummary()?.areAllCheckboxesChecked("correctiveAction")) {
      params["correctiveAction"] = filters.correctiveAction.map((item) => `'${item}'`).join("\\,");
    }
    if (
      !SmartFilterRegistry.getSummary()?.areAllCheckboxesChecked("correctiveAction") &&
      $('input[name="correctiveAction"][value="no-action"]').is(":checked")
    ) {
      params[`includeNoAction`] = true;
    }
    if (!SmartFilterRegistry.getSummary()?.areAllCheckboxesChecked("enforcementLevel")) {
      params["enforcementLevel"] = filters.enforcementLevel.map((item) => `'${item}'`).join("\\,");
    }
    if (
      !SmartFilterRegistry.getSummary()?.areAllCheckboxesChecked("enforcementLevel") &&
      $('input[name="enforcementLevel"][value="null"]').is(":checked")
    ) {
      params[`includeNoActionLevel`] = true;
    }
    ResourceFilters.addDateParam(
      params,
      "routine",
      filters.routineDate?.from,
      filters.routineDate?.to,
    );
    ResourceFilters.addDateParam(
      params,
      "repair",
      filters.repairDate?.from,
      filters.repairDate?.to,
    );
  };

  var isOnlineDateFilterSet = function (filters) {
    return false;
  };

  var addGeoServerFilterQuery = function (queryStrings, filters) {
    if (filters.searchString) {
      queryStrings.push(
        GeoServerFilterFunctions.getSearchQuery(searchDbFields, filters.searchString),
      );
    }
    GeoServerFilterFunctions.addFilterToGeoServerQuery(
      queryStrings,
      filters,
      "implementerType",
      "implementer_type",
    );

    GeoServerFilterFunctions.addFilterToGeoServerQuery(
      queryStrings,
      filters,
      "responsiblePartyMaintenance",
      "responsible_party_maintenance",
    );

    GeoServerFilterFunctions.addFilterToGeoServerQuery(
      queryStrings,
      filters,
      "landOwnership",
      "property",
    );

    GeoServerFilterFunctions.addFilterToGeoServerQuery(
      queryStrings,
      filters,
      "openChannelType",
      "type",
    );

    GeoServerFilterFunctions.addFilterToGeoServerQuery(
      queryStrings,
      filters,
      "serviceType",
      "service_type",
    );

    GeoServerFilterFunctions.addFilterToGeoServerQuery(
      queryStrings,
      filters,
      "flowType",
      "flow_type",
    );
    if (!SmartFilterRegistry.getSummary()?.areAllCheckboxesChecked("condition")) {
      GeoServerFilterFunctions.addMuniConditionFilterToGeoServerQuery(queryStrings, filters);
    }

    GeoServerFilterFunctions.addFilterToGeoServerQuery(
      queryStrings,
      filters,
      "implementationPhase",
      "phase",
    );

    if (
      filters.accessible?.length !== undefined &&
      !SmartFilterRegistry.getSummary()?.areAllCheckboxesChecked("accessible")
    ) {
      GeoServerFilterFunctions.yesNoNullGeoServerFilter(
        filters,
        "accessible",
        queryStrings,
        "accessible",
        filters.accessible,
      );
    }

    if (
      filters.lined?.length !== undefined &&
      !SmartFilterRegistry.getSummary()?.areAllCheckboxesChecked("lined")
    ) {
      GeoServerFilterFunctions.yesNoNullGeoServerFilter(
        filters,
        "lined",
        queryStrings,
        "lined",
        filters.lined,
      );
    }

    if (filters.installDate) {
      GeoServerFilterFunctions.addDateQuery(
        queryStrings,
        "install_date",
        filters.installDate?.from,
        filters.installDate?.to,
      );
    }

    GeoServerFilterFunctions.addFilterToGeoServerQuery(
      queryStrings,
      filters,
      "cof",
      "cof_final_text",
    );

    GeoServerFilterFunctions.addFilterToGeoServerQuery(queryStrings, filters, "shape", "shape");
    const lengthWidthQueries = [];
    const diameterQuery = [];

    GeoServerFilterFunctions.addFeetAndInchesMinMaxMeasurmentQuery(
      "length",
      filters.lengthRange,
      "length_units",
      lengthWidthQueries,
    );
    GeoServerFilterFunctions.addFeetAndInchesMinMaxMeasurmentQuery(
      "width",
      filters.widthRange,
      "width_units",
      lengthWidthQueries,
    );

    const shapeDbColumnName = "shape";
    const indexOfShapeQuery = MeasurementMinMax.findIndexOfShapeQuery(
      queryStrings,
      shapeDbColumnName,
    );
    GeoServerFilterFunctions.createMinMaxMeasurmentCombinedQuery(
      queryStrings,
      lengthWidthQueries,
      diameterQuery,
      indexOfShapeQuery,
      shapeDbColumnName,
      filters,
    );
  };

  var getFilterConfigs = function () {
    return {
      implementerType: "implementerType",
      responsiblePartyMaintenance: "responsiblePartyMaintenance",
      landOwnership: "landOwnership",
      openChannelType: "openChannelType",
      serviceType: "lineServiceType",
      flowType: "flowType",
      condition: "condition",
      implementationPhase: "phase",
      accessible: "accessible",

      cof: "cof",
      drainsToRw: ["drains_to_rws", "array"],
      drainsToC: ["drains_to_cs", "array"],
      catchmentName: ["catchment_names", "array"],
      catchments: ["catchment_names", "array"],
      zones: ["zone_names", "array"],
      maintenanceZones: ["zone_names", "array"],
      correctiveAction: ["correctiveAction", "array"],
      enforcementLevel: ["enforcementLevel", "array"],
      shape: "shape",
      lined: "lined",
      subGroups: "groupId",
      routineDate: (datum, filters) =>
        ResourceFilters.passDatesFilter(
          datum.routine,
          filters.routineDate?.from,
          filters.routineDate?.to,
        ),
      repairDate: (datum, filters) =>
        ResourceFilters.passDatesFilter(
          datum.repair,
          filters.repairDate?.from,
          filters.repairDate?.to,
        ),

      otherFilters: (datum, filters) => {
        return (
          ResourceFilters.passSearchStringFilter(datum, filters, searchFields) &&
          ResourceFilters.passIsoDateFilter(
            datum.installDate,
            filters.installDate?.from,
            filters.installDate?.to,
          ) &&
          MeasurementMinMax.passLengthWidthFilter(
            datum.shape,
            filters.shape,
            datum.length,
            datum.lengthUnits,
            datum.width,
            datum.widthUnits,
            { max: filters.lengthRange?.max, min: filters.lengthRange?.min },
            { max: filters.widthRange?.max, min: filters.widthRange?.min },
          )
        );
      },
    };
  };

  return {
    filterResourceDataHandler,
    isOnlineDateFilterSet,
    addGeoServerFilterQuery,
    addGeoServerViewParams,
    getFilterConfigs,
  };
};

module.exports = MuniOpenChannelFilters();

const ResourceFilters = require("../../filters/resourceFilters");
const GeoServerFilterFunctions = require("../../mapFunctions/geoServerFilterFunctions");
const SmartFilterRegistry = require("../../filters/smartFilterRegistry");
const MeasurementMinMax = require("../../general/measurementMinMax");
